// extracted by mini-css-extract-plugin
export default {"emptyResultWrap":"emptyResult_emptyResultWrap__tkJuE"};